import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Button,
  Row,
  Col,
  message,
  Radio,
  Select,
  Alert,
  notification,
  Spin,
  Result,
} from "antd";
import Axios from "axios";
import {
  BrowserRouter as Router,
  Route,
  Link,
  Switch,
  useNavigate,
} from "react-router-dom";
import {
  environmentVariable,
  environment,
  apiRoutes,
} from "../../auth/apiRoute";
import {
  HomeTwoTone,
  SettingTwoTone,
  SmileOutlined,
  SyncOutlined,
  LoadingOutlined,
  ArrowLeftOutlined,
  SmileTwoTone,
} from "@ant-design/icons";
import LoadingFrame from "../../layout/loadingFrame";
const gutterLayout = { xs: 8, sm: 16, md: 24, lg: 32 };
const layout = {
  wrapperCol: {
    span: 24,
  },
};
const validateMessages = {
  required: "${label} is required!",
  types: {
    email: "${label} is not a valid email!",
    number: "${label} is not a valid number!",
  },
  number: {
    range: "${label} must be between ${min} and ${max}",
  },
};
export default function Addnomination(props) {
  const { Option } = Select;
  const { TextArea } = Input;
  const [form] = Form.useForm();
  const [user, setUser] = useState({});
  const [loading, setLoading] = useState(false);
  const [selectedHotel, setSelectedHotel] = useState();
  const navigate = useNavigate();
  const [hotels, setHotels] = useState([]);
  const categories = [
    "Full-Time Hourly With Guest Contact",
    "Full-Time Hourly Without Guest Contact",
    "Full-Time Room Attendant",
    "Managerial Below General Manager",
  ];
  const questions = [
    "1. Describe the employee’s overall job performance and dedication to his/her profession and to your Hotel. Please be specific and cite at least one example.",
    "2.  Describe the interaction of the employee with his/her coworkers and/or with guests. Please cite specific examples of the employee’s positive impact on the guest experience at your hotel. ",

    "3. Please list any awards or recognition that the employee has received from the Hotel, management, guests, award organizations and/or peers.",
    "4. Please list any other reasons for nominating this employee for the Big Apple Stars Awards.",
  ];
  useEffect(() => {
    getUser();
  }, [props.user]);
  const getUser = async () => {
    setLoading(true);
    try {
      const response = await Axios.post(apiRoutes[environment].getprofile, {
        id: props.user.id,
      });
      if (!response.data) {
        navigate(`/member/${props.user.id}/profile`);
      }
      if (response.status == 200) {
        setUser(response.data);

        setHotels(response.data.hotels);
      }
    } catch (error) {
      if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        message.error({
          content: "Sorry, there was an error. " + error.response.data.message,
          className: "messageBox",
        });
      }
    }
    setLoading(false);
  };
  const onFinish = async (values) => {
    console.log(values);
    var term = new Date().getFullYear();
    var dataValue = values;
    dataValue.term = term;
    submitInfo(dataValue);
    var message = "Success! We've received your payment!";
  };

  const submitInfo = async (value) => {
    try {
      const response = await Axios.post(
        apiRoutes[environment].updateNomination,
        value
      );
      console.log(response);
      if (response.status == 200) {
        openNotification();
        form.resetFields();
        getUser();
        setSelectedHotel();
      }
    } catch (error) {
      if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        message.error({
          content: "Sorry, there was an error. " + error.response.data.message,
          className: "messageBox",
        });
      }
    }
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };
  function onChange(e) {
    var hotelId = e.target.value;
    var hotelSelected = user.hotels.find((item) => item._id == hotelId);
    console.log({ hotelSelected });
    setSelectedHotel(hotelSelected);
    console.log(`radio checked:${e.target.value}`);
  }
  function handleChange(value) {
    console.log(`selected ${value}`);
  }
  const hotelRadioGroup = () => {
    var term = new Date().getFullYear();

    if (hotels) {
      return hotels.map((hotel) => {
        var isDisabled = false;
        var hotelNominations = hotel.nominations;
        if (hotelNominations) {
          isDisabled =
            hotelNominations.filter((item) => item.term == term).length >= 4;
        }

        return (
          <Radio key={hotel._id} value={hotel._id} disabled={isDisabled}>
            {hotel.name}
          </Radio>
        );
      });
    }
  };
  const cateogryOptions = (selectedHotel) => {
    var term = new Date().getFullYear();
    console.log(term);
    if (!selectedHotel) {
      return;
    }

    return categories.map((category) => {
      var isDisabled = false;
      // var hotelNominations = selectedHotel.nominations;

      if (selectedHotel && selectedHotel.nominations) {
        var allNominationsByTerm = selectedHotel.nominations.filter(
          (item) => item.term == term
        );
        var allNominationsCategories = allNominationsByTerm.map(
          (item) => item.category
        );

        isDisabled = allNominationsCategories.includes(category);
      }

      return (
        <Option value={category} key={category} disabled={isDisabled}>
          {category}
        </Option>
      );
    });
  };

  const showQuestions = () => {
    return questions.map((question, index) => {
      return (
        <Row gutter={gutterLayout} key={"q" + (index + 1)}>
          <Col span={24}>
            <Form.Item name={["q" + (index + 1), "answer"]} label={question}>
              <TextArea rows={4} />
            </Form.Item>
          </Col>
        </Row>
      );
    });
  };
  const openNotification = (message) => {
    notification.success({
      message: `Success!`,
      description:
        "Your nomination has been successfully submitted! You will receive an email confirmation shortly.",
      placement: "top",
    });
  };
  return (
    <div>
      <div style={{ marginBottom: "10px" }}>
        <Button onClick={() => navigate(-1)}>
          <ArrowLeftOutlined />
          go back
        </Button>
      </div>
      {props.isAcceptingNomination ? (
        <LoadingFrame loading={loading}>
          <Form
            form={form}
            {...layout}
            name="nest-messages"
            layout="vertical"
            onFinish={onFinish}
            validateMessages={validateMessages}
            initialValues={{ user: user, hotel: null }}
          >
            <Row gutter={gutterLayout}>
              <Col xs={24} md={24}>
                <Form.Item
                  name={"hotel"}
                  label="Hotel"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Radio.Group onChange={onChange} defaultValue={null}>
                    {hotelRadioGroup()}
                  </Radio.Group>
                </Form.Item>
                {hotels.length > 0 ? (
                  <></>
                ) : (
                  <Alert
                    message="You need at least one hotel to start nominations."
                    type="error"
                    action={
                      <Button size="small" danger>
                        <Link to={`/member/${props.user.id}/profile`}>
                          Update Now
                        </Link>
                      </Button>
                    }
                  />
                )}
              </Col>
            </Row>
            <Row gutter={gutterLayout}>
              <Col xs={24} md={24}>
                <Form.Item
                  name={"category"}
                  label="Category"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Select style={{ width: 400 }} onChange={handleChange}>
                    {cateogryOptions(selectedHotel)}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={gutterLayout}>
              <Col span={12}>
                <Form.Item
                  name={"firstName"}
                  label="First Name"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name={"lastName"}
                  label="Last Name"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={gutterLayout}>
              <Col span={24}>
                <Form.Item
                  name={"title"}
                  label="Position"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>
            </Row>

            {showQuestions()}

            <Row gutter={gutterLayout}>
              <Col span={24}>
                <Form.Item>
                  <Button
                    type="primary"
                    disabled={loading ? true : false}
                    htmlType="submit"
                    block
                  >
                    Confirm
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </LoadingFrame>
      ) : (
        <>
          <Result
            icon={<SmileOutlined />}
            title="Sorry, but the nomination is no longer accepted."
            extra={
              <Button type="primary">
                <Link to={"/member/nominations"}>Check my nominations</Link>
              </Button>
            }
          />
        </>
      )}
    </div>
  );
}
